<template>
  <div>
    <button
      type="button"
      class="btn btn-outline-primary btn-sm"
      data-toggle="modal"
      :data-target="`#modalShareLink${infoId}`"
      href="#"
    >
      <i class="far fa-share-alt"></i>
      Share Invite Link
    </button>

    <div
      class="modal fade"
      :id="`modalShareLink${infoId}`"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalShareLinkTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header border-none">
            <label class="modal-title fs-20 fw-700 c-primary" id="exampleModalLongTitle">
              Link Telekonsul
            </label>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body bg-gray-F">
            <div align="center" class="mt-2" v-if="$store.state.roleDokter">
              <h6>Link Telekonsul Dokter:</h6>
              <div
                class="box-copy-link"
              >
                <span
                  class="d-inline-block text-truncate align-middle"
                >
                  {{ linkDokter }}
                </span>
                <button
                  type="button"
                  class="btn btn-default btn-copy js-tooltip js-copy"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Copy to clipboard"
                  @click="copyCommand(linkDokter)"
                >
                  <span class="fs-14 fw-500 c-primary"><i class="fa fa-regular fa-clone fw-500"></i> Copy</span>
                </button>
              </div>
              <input type="hidden" id="linkUrl" :value="linkDokter" />
            </div>

            <div align="center" class="mt-4">
              <h6>Pasien belum masuk? Share link ke pasien</h6>
              <div
                class="box-copy-link"
              >
                <span
                  class="d-inline-block text-truncate align-middle"
                  id="linkPasien"
                >
                  {{ linkPasien }}
                </span>
                <button
                  type="button"
                  class="btn btn-default btn-copy js-tooltip js-copy"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Copy to clipboard"
                  @click="copyCommand(linkPasien)"
                >
                  <span class="fs-14 fw-500 c-primary"><i class="fa fa-regular fa-clone fw-500"></i> Copy</span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer border-none">
            <button type="button" class="btn-primary-telekonsul border-radius-12 fs-14 text-white fw-700" data-dismiss="modal">Tutup</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkPasien: this.$store.state.linkPasien,
      linkDokter: "",
    };
  },
  props: ["infoId"],
  methods: {
    copyCommand(text) {
      var textField = document.createElement("textarea");
      textField.innerText = text;
      document.body.appendChild(textField);
      textField.select();
      textField.focus(); //SET FOCUS on the TEXTFIELD
      document.execCommand("copy");
      textField.remove();
      console.log("should have copied " + text);
    },
  },
  mounted() {
    // copy
    function copyToClipboard(text, el) {
      var copyTest = document.queryCommandSupported("copy");
      var elOriginalText = el.attr("data-original-title");

      if (copyTest === true) {
        var copyTextArea = document.createElement("textarea");
        copyTextArea.value = text;
        document.body.appendChild(copyTextArea);
        copyTextArea.select();
        try {
          var successful = document.execCommand("copy");
          var msg = successful ? "Copied!" : "Whoops, not copied!";
          el.attr("data-original-title", msg).tooltip("show");
        } catch (err) {
          console.log("Oops, unable to copy");
        }
        document.body.removeChild(copyTextArea);
        el.attr("data-original-title", elOriginalText);
      } else {
        // Fallback if browser doesn't support .execCommand('copy')
        window.prompt("Copy to clipboard: Ctrl+C or Command+C, Enter", text);
      }
    }

    $(".js-tooltip").tooltip();

    $(".js-copy").click(function() {
      var text = $(this).attr("data-copy");
      var el = $(this);
      copyToClipboard(text, el);
    });
    const setQueryParam = localStorage.linkParams
    this.linkDokter = `${window.location.origin}${setQueryParam}`;
  },
};
</script>

<style></style>
